export const menuMobile = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const menuMobile = document.querySelector('.mobile-menu-dialog');
    const menuMobileOpen = document.querySelector('.mobile-menu-dialog__open');
    const menuMobileClose = document.querySelector('.mobile-menu-dialog__close');

    if (!menuMobile) return;


    const allParentItems = menuMobile.querySelectorAll(
      '.mobile-menu-view li.menu-item-has-children'
    );

    allParentItems.forEach(li => {
      const directSubmenu = li.querySelector(':scope > ul.sub-menu');

      if (!directSubmenu) return;

      const hasNested = directSubmenu.querySelector(
        ':scope > li.menu-item-has-children'
      );

      if (hasNested) {
        li.classList.add('has-nested-submenu');
      } else {
        li.classList.add('has-simple-submenu');
      }
    });

    menuMobileOpen.addEventListener('click', () => {
      menuMobile.classList.add('active');
      menuMobileOpen.classList.remove('active');
      menuMobileClose.classList.add('active');
    });

    menuMobileClose.addEventListener('click', () => {
      menuMobile.classList.remove('active');
      menuMobileOpen.classList.add('active');
      menuMobileClose.classList.remove('active');
    });

    const menuItemsWithChildren = menuMobile.querySelectorAll(
      '.mobile-menu-view li.menu-item-has-children > a'
    );

    menuItemsWithChildren.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const parentLi = link.parentElement;
        const isOpen = parentLi.classList.contains('open');

        parentLi.parentElement
          .querySelectorAll(':scope > li.menu-item-has-children')
          .forEach(li => {
            if (li !== parentLi) {
              li.classList.remove('open');
            }
          });

        if (isOpen) {
          parentLi.classList.remove('open');
        } else {
          parentLi.classList.add('open');
        }
      });
    });
  });
};